export default {"src":"/_next/static/media/circleArrowUp_40.286b8ade.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};